module.exports = __webpack_public_path__ + "img/CR.29c9c44f.svg";